import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postData } from '../Services/api'

const POTypeAdd = () => {
    const [values, setValues] = useState({ type_name: "" })
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const res = await postData('/po-types/create', values);
            if (res.status) {
                toast.success(res.message)
                navigate('/po-types/po-type-list');
                setValues({ type_name: "" })
            } else {
                toast.error(res.message)
            }
        } catch (error) {
            console.log("error po type adding", error)
            toast.error(error.response.data.message || 'error')
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/po-types/po-type-list">PO Type</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add PO Type
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Add PO Type</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add PO Type</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">PO Type Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter PO Type"
                                                        name='type_name'
                                                        value={values.type_name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/po-types/po-type-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default POTypeAdd
